import { MetrikaCounterEditorData, MetrikaCounterEditorValue } from '../typings/metrikaCounterEditor';

export function mapMetrikaCountersEditorValueToCampaignMetrikaCountersValue(
    metrikaCounters: MetrikaCounterEditorData
): MetrikaCounterEditorValue {
    return {
        counters: metrikaCounters.appliedCounters || [],
        markMetrikaLinks: metrikaCounters.markMetrikaLinks
    };
}
